// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lPrVs","colBig":"styles_colBig__3nE1I","colSmall":"styles_colSmall__EOUZc"};